export enum FeeType {
    '203K_SUPPLEMENTAL_FEE' = '203K_SUPPLEMENTAL_FEE',
    ADMINISTRATION_FEE = 'ADMINISTRATION_FEE',
    CDFI_CREDIT = 'CDFI_CREDIT',
    CODE_COMPLIANCE_FEE = 'CODE_COMPLIANCE_FEE',
    COMPLIANCE_FEE = 'COMPLIANCE_FEE',
    CONDO_REVIEW = 'CONDO_REVIEW',
    DOCUMENT_FEE = 'DOCUMENT_FEE',
    DPA_REIMBURSED_BY_TSACH = 'DPA_REIMBURSED_BY_TSACH',
    DPA_REIMBURSEMENT = 'DPA_REIMBURSEMENT',
    EARLY_RENO_REVIEW_FEE = 'EARLY_RENO_REVIEW_FEE',
    ELECTRONIC_UPLOAD_FEE = 'ELECTRONIC_UPLOAD_FEE',
    FHA_MANUAL_UW = 'FHA_MANUAL_UW',
    FLOOD_CERT_FEE = 'FLOOD_CERT_FEE',
    FLOOD_DETERMINATION = 'FLOOD_DETERMINATION',
    FLOOD_TRANSFER_FEE = 'FLOOD_TRANSFER_FEE',
    FUNDING_FEE = 'FUNDING_FEE',
    LENDER_FEE = 'LENDER_FEE',
    LOCK_PURCHASE_EXTENSION_FEE = 'LOCK_PURCHASE_EXTENSION_FEE',
    MCC_FEE = 'MCC_FEE',
    MERS_FEE = 'MERS_FEE',
    OTHER = 'OTHER',
    PIA_FEE = 'PIA_FEE',
    PIW_FEE = 'PIW_FEE',
    PREMIER_EVALUATING_FEE = 'PREMIER_EVALUATING_FEE',
    PROGRAM_APPLICATION_FEE = 'PROGRAM_APPLICATION_FEE',
    REFINOW_APPRAISAL_FEE = 'REFINOW_APPRAISAL_FEE',
    REFIPOSSIBLE_APPRAISAL_FEE = 'REFIPOSSIBLE_APPRAISAL_FEE',
    SBHL_FEE = 'SBHL_FEE',
    SPECIAL_PROGRAM_CREDIT = 'SPECIAL_PROGRAM_CREDIT',
    SUPPLEMENTAL_ORIGINATION_FEE = 'SUPPLEMENTAL_ORIGINATION_FEE',
    SUSPENSE_FEE = 'SUSPENSE_FEE',
    TAX_SERVICE_FEE = 'TAX_SERVICE_FEE',
    TEXAS_DPA_FEE = 'TEXAS_DPA_FEE',
    TX50A6 = 'TX50A6',
    UFMIP_FEE = 'UFMIP_FEE',
    UNDERWRITING_AND_PURCHASE_FEE = 'UNDERWRITING_AND_PURCHASE_FEE',
    UNDERWRITING_FEE = 'UNDERWRITING_FEE',
    VA_FUNDING_FEE = 'VA_FUNDING_FEE'
}

export const feeTypeDisplay = {
    [FeeType['203K_SUPPLEMENTAL_FEE']]: '203k supplemental fee',
    [FeeType.ADMINISTRATION_FEE]: 'Administration fee',
    [FeeType.CDFI_CREDIT]: 'Cdfi credit',
    [FeeType.CODE_COMPLIANCE_FEE]: 'Code compliance fee',
    [FeeType.COMPLIANCE_FEE]: 'Compliance fee',
    [FeeType.CONDO_REVIEW]: 'Condo review',
    [FeeType.DOCUMENT_FEE]: 'Document fee',
    [FeeType.DPA_REIMBURSED_BY_TSACH]: 'Dpa reimbursed by tsach',
    [FeeType.DPA_REIMBURSEMENT]: 'Dpa reimbursement',
    [FeeType.EARLY_RENO_REVIEW_FEE]: 'Early reno review fee',
    [FeeType.ELECTRONIC_UPLOAD_FEE]: 'Electronic upload fee',
    [FeeType.FHA_MANUAL_UW]: 'Fha manual uw',
    [FeeType.FLOOD_CERT_FEE]: 'Flood cert fee',
    [FeeType.FLOOD_DETERMINATION]: 'Flood determination',
    [FeeType.FLOOD_TRANSFER_FEE]: 'Flood transfer fee',
    [FeeType.FUNDING_FEE]: 'Funding fee',
    [FeeType.LENDER_FEE]: 'Lender fee',
    [FeeType.LOCK_PURCHASE_EXTENSION_FEE]: 'Lock purchase extension fee',
    [FeeType.MCC_FEE]: 'Mcc fee',
    [FeeType.MERS_FEE]: 'Mers fee',
    [FeeType.OTHER]: 'Other',
    [FeeType.PIA_FEE]: 'Pia fee',
    [FeeType.PIW_FEE]: 'Piw fee',
    [FeeType.PREMIER_EVALUATING_FEE]: 'Premier evaluating fee',
    [FeeType.PROGRAM_APPLICATION_FEE]: 'Program application fee',
    [FeeType.REFINOW_APPRAISAL_FEE]: 'Refinow appraisal fee',
    [FeeType.REFIPOSSIBLE_APPRAISAL_FEE]: 'Refipossible appraisal fee',
    [FeeType.SBHL_FEE]: 'Sbhl fee',
    [FeeType.SPECIAL_PROGRAM_CREDIT]: 'Special program credit',
    [FeeType.SUPPLEMENTAL_ORIGINATION_FEE]: 'Supplemental origination fee',
    [FeeType.SUSPENSE_FEE]: 'Suspense fee',
    [FeeType.TAX_SERVICE_FEE]: 'Tax service fee',
    [FeeType.TEXAS_DPA_FEE]: 'Texas dpa fee',
    [FeeType.TX50A6]: 'Tx50 a6',
    [FeeType.UFMIP_FEE]: 'Ufmip fee',
    [FeeType.UNDERWRITING_AND_PURCHASE_FEE]: 'Underwriting and purchase fee',
    [FeeType.UNDERWRITING_FEE]: 'Underwriting fee',
    [FeeType.VA_FUNDING_FEE]: 'Va funding fee'
};
